<template>
  <div>
    <b-form @submit="createTechnician">
      <b-row>
        <b-col cols="12">
          <label class="text-grey">Nombre</label>
          <b-form-input
            required
            type="text"
            v-model="formTech.name"
            placeholder="Escriba aquí"
          ></b-form-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" class="padding-two-top">
          <label class="text-grey">DNI</label>
          <b-form-input
            required
            type="text"
            v-model="formTech.identityDocument"
            placeholder="Escriba aquí"
          ></b-form-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" class="padding-two-top">
          <label class="text-grey">Teléfono</label>
          <b-form-input
            required
            type="text"
            v-model="formTech.phone"
            placeholder="Escriba aquí"
            maxlength="9"
            @keyup="filterInput"
          ></b-form-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" class="padding-two-top">
          <label class="text-grey">Proveedor</label>
          <template v-if="isProfileProvider">
            <b-form-group>
              <b-form-select
                :value="formTech.providerId"
                size="md"
                :options="optionsProvider"
              >
              </b-form-select>
            </b-form-group>
          </template>
          <template v-else>
            <search-provider @rowSelectedProvider="setOptionSelected">
              <template slot="body">
                <b-form-input
                  :disabled="true"
                  class="border-right-none"
                  v-model="userProvider"
                  size="md"
                  placeholder="Ingrese el usuario"
                >
                </b-form-input>
              </template>
            </search-provider>
            <!-- <b-form-group>
              <b-form-select
                required
                @change="setValueSelected"
                v-model="valProvider"
                size="md"
                :options="optionsProvider"
              >
                <b-form-select-option :value="null"
                  >Seleccione una opción
                </b-form-select-option>
              </b-form-select>
            </b-form-group>-->
          </template>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <label class="text-grey">Estado</label>
          <b-form-group>
            <b-form-select
              required
              v-model="formTech.state"
              size="md"
              :options="optionStates"
            >
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" >
          <label class="text-grey">Contraseña</label>
          <b-form-input
            required
            type="password"
            v-model="formTech.password"
            placeholder="Escriba aquí"
          ></b-form-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" class="text-center">
          <b-button class="bg-orange-btn" type="submit">
            <font-awesome-icon icon="save" /> Guardar
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>
<script>
import axios from "axios";
import { mapState } from "vuex";
import SearchProvider from "../AdminOS/SearchProvider.vue";
export default {
  components: { SearchProvider },
  name: "RegisterTechnician",
  data() {
    return {
      valProvider: null,
      optionsProvider: [],
      formTech: {
        identityDocument: "",
        name: "",
        phone: "",
        providerId: null,
        providerName: "",
        state: "ACTIVE",
        password:""
      },
      userProvider: null,
      optionStates: [
        { value: "ACTIVE", text: "ACTIVO" },
        { value: "INACTIVE", text: "INACTIVO" },
      ],
    };
  },
  computed: {
    ...mapState("module", ["perfil", "idProvider", "name","token"]),
    isProfileProvider() {
      let up = this.perfil.toUpperCase();
      if (up === "PROVEEDOR") return true;
      return false;
    },
  },
  created() {
    this.getProviders();
  },
  methods: {
    async getProviders() {
      if (this.isProfileProvider) {
        await this.getFilteredProviders();
      } else {
        this.getProvidersList();
      }
    },
    async getFilteredProviders() {
      try {
        let response = await axios.get(
          process.env.VUE_APP_ENDPOINT_PROVIDERS_CORE_BASE +
            "/providers/" +
            this.idProvider,
            {
              headers: {
              "Content-type": "application/json",
              "Authorization": "Bearer "+ this.token
              },
            }
        );
        this.formTech.providerId = response.data.id;
        this.formTech.providerName = response.data.name;
        let arr = [];
        arr.push(response.data);
        const data = arr.map((row) => {
          return {
            value: row.id,
            text: row.user,
          };
        });

        this.optionsProvider = data;
      } catch (error) {
        console.log(error);
      }
    },
    filterInput() {
      this.formTech.phone = this.formTech.phone.replace(/[^0-9]/g, "");
    },
    setOptionSelected(selected) {
      if (selected.length) {
        this.formTech.providerId = selected[0].id;
        this.formTech.providerName = selected[0].name;
        this.userProvider = selected[0].user;
      }
    },

    async getProvidersList() {
      try {
        let response = await axios.get(
          process.env.VUE_APP_PROVIDER_BASE_BUSINESS +
            "/providers?limit=1000&page=1&pagination=true"
        );
        const data = response.data.map((row) => {
          return {
            value: { providerId: row.id, providerName: row.name },
            text: row.name,
          };
        });
        this.optionsProvider = data;
      } catch (error) {
        console.log(error);
      }
    },
    async createTechnician() {
      event.preventDefault();
      try {
        this.$store.commit("SET_LOADING", true);

        let response = await axios.post(
          process.env.VUE_APP_ENDPOINT_PROVIDERS_CORE_BASE + "/technicians",
          this.formTech,
          {
              headers: {
              "Content-type": "application/json",
              "Authorization": "Bearer "+ this.token
              },
            }
        );
        console.log(response);
        let values = { variant: "success", msg: "Se ha creado exitosamente !" };
        this.$store.commit("setShowAlert", true);
        this.$store.commit("SET_ERROR_MSG", values);
      } catch (error) {
        console.log(error);
        let values = { variant: "danger", msg: error.response.data.message };
        this.$store.commit("setShowAlert", true);
        this.$store.commit("SET_ERROR_MSG", values);
      } finally {
        this.$store.commit("SET_LOADING", false);
      }
    },
  },
};
</script>
<style scoped>
.padding-two-top {
  padding-top: 2%;
}
::v-deep .modal-title {
  color: #ff7a00 !important;
  font-weight: 500;
}

::v-deep .modal-title {
  color: #ff7a00 !important;
  font-weight: 500;
}
</style>
